import { call, put } from 'redux-saga/effects';

import request from './request';
import {
  fetchAlertsFailed,
  fetchAlertsRequested,
  fetchAlertsSucceeded,
  fetchAlertsOccurFailed,
  fetchAlertsOccurRequested,
  fetchAlertsOccurSucceeded,
  fetchAlertsResFailed,
  fetchAlertsResRequested,
  fetchAlertsResSucceeded,
  updateAlertsDisplayed,
  fetchAlertDataFailed,
  fetchAlertDataRequested,
  fetchAlertDataSucceeded,
} from '../../../actions';
import api from '../../../api';

export function* fetchAlertsRequest() {
  yield put(fetchAlertsRequested());

  try {
    const { items } = yield call(request, api.getAlerts);

    const action = fetchAlertsSucceeded(items);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchAlertsFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchAlertDataRequest(deviceId, data) {
  yield put(fetchAlertDataRequested(deviceId, data));

  try {
    const { items } = yield call(request, api.getAlertData, deviceId, data);

    const action = fetchAlertDataSucceeded(data.alertId, items);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchAlertDataFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchAlertsOccurRequest() {
  yield put(fetchAlertsOccurRequested());

  try {
    const { items } = yield call(request, api.getAlertsOccur);

    const action = fetchAlertsOccurSucceeded(items);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchAlertsOccurFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* fetchAlertsResRequest() {
  yield put(fetchAlertsResRequested());

  try {
    const { items } = yield call(request, api.getAlertsRes);

    const action = fetchAlertsResSucceeded(items);
    yield put(action);

    return {
      success: true,
      payload: action.payload,
    };
  } catch (error) {
    const action = fetchAlertsResFailed(error);
    yield put(action);

    return {
      success: false,
      payload: action.payload,
    };
  }
}

export function* updateAlertsDisplayRequest() {
  yield put(updateAlertsDisplayed());
}
